import { Button, type ButtonProps, useTheme } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	expanded: boolean;
	onClick: () => void;
	collapsedLabel?: string;
	expandedLabel?: string;
	variant?: ButtonProps["variant"];
	sx?: ButtonProps["sx"];
};

export const ShowAllToggleButton: FC<Props> = ({
	expanded,
	onClick,
	collapsedLabel,
	expandedLabel,
	variant = "showAll",
	sx,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	const Chevron = expanded ? ChevronUp : ChevronDown;
	const label = expanded
		? (expandedLabel ?? t(Resources.Common.Hide))
		: (collapsedLabel ?? t(Resources.Common.DisplayAll));

	return (
		<Button
			variant={variant}
			onClick={onClick}
			aria-expanded={expanded}
			endIcon={<Chevron size={theme.iconSize.sm} />}
			sx={sx}
		>
			{label}
		</Button>
	);
};
